import { useQuery } from '@gogame/query';
import { loadChat } from 'scenes/AIChatbot/sources/chats';
import { chat } from './queryKeyFactory';

export const useLoadChat = (id) => {
  return useQuery(chat(id), (_, { signal }) => loadChat({ id }, { signal }), {
    enabled: !!id,
  });
};
